import { select } from '@js/util/select.js'
import Swiper, { Pagination, Autoplay } from 'swiper'
Swiper.use([Pagination, Autoplay])

select('.wpce-testimonial', testimonialElement => {
  if (!testimonialElement.dataset.swiperId) return

  const options = {
    direction: 'horizontal',
    loop: true,
    threshold: 30,
    centeredSlides: true,
    slidesPerView: 1,
    autoplay: false,
    autoHeight: true,
    pagination: {
      el: '.testimonial-pagination',
      type: 'bullets',
      clickable: 'true',
    },
  }

  if ('autoplayDuration' in testimonialElement.dataset) {
    options.autoplay = {
      disableOnInteraction: true,
      delay: parseFloat(testimonialElement.dataset.autoplayDuration) * 1000,
    }
  }

  const swiper = new Swiper(`#${testimonialElement.dataset.swiperId}`, options)

  swiper.on('slideChange', () => {
    if (swiper.autoplay.running) return

    if (testimonialElement.getBoundingClientRect().top < 100) {
      window.scrollTo({
        top: testimonialElement.getBoundingClientRect().top + window.scrollY,
        behavior: 'smooth',
      })
    }
  })

  return () => {
    swiper.destroy()
  }
})
